import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../i18n/context';
import './RebateBanner.css';

function RebateBanner() {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <div className="rebate-banner" onClick={() => navigate('/rebate')}>
      <div className="rebate-banner-text">
        <h3>{t('rebate.bannerTitle')}</h3>
        <p>{t('rebate.bannerDesc')}<span className="rebate-banner-code">YL188</span></p>
      </div>
      <button className="rebate-banner-btn">{t('rebate.bannerCta')}</button>
    </div>
  );
}

export default RebateBanner;
